import Organization from 'entities/Organization';
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LOAD_ORGANIZATION',
  'LOAD_USER_ORGANIZATIONS',
  'REMOVE_ORGANIZATION',
  'REMOVE_ADMIN_ROLE',
  'UPDATE_CURRENT_USER_ORGANIZATION_AFFILIATION',
  'UPDATE_ORG_AFF_VIEW',
]);

export const NO_SCHOOL = new Organization({ id: null, name: 'I don’t work at a school' });
export const UNAFFILIATED = new Organization({ id: null, name: 'Not affiliated with a school' });
